<icc-list [searchable]="true" [items]="items"
          [itemTemplate]="'itemImgTitleDescription'"
          itemWidth="full"
          [ignoreTemplateWidth]="true"
          itemImgHeight="medium"
          (select)="selectItem($event)"
          [selected] = "selectedItemId"
></icc-list>